<template>
  <my-card shadow="never">
    <div slot="header">
      <div style="display: flex; justify-content: space-between">
        <div class="title">分析列表</div>
        <div style="display: flex; align-items: center">
          <icon
            style="width: 16px; height: 16px; margin-right: 10px"
            name="download"
            @click="handleExportTableData"
          ></icon>

          <div>
            <t-switch size="large" v-model="tableShowType" @change="handleChangeTableShowType"></t-switch>
            <span style="margin-left: 10px">{{ tableShowType ? '展开日期' : '收起日期' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="" v-if="loading || oriTableList.length">
      <el-table
        ref="multipleTable"
        :data="tableList"
        :row-class-name="handleTableRowClassName"
        :span-methods="handleTableSpanMethod"
        header-row-class-name="analysis-table-header"
        v-loading="loading"
        tooltip-effect="dark"
        style="width: 100%"
        border
        align="center"
      >
        <template v-for="col in tableColumns">
          <el-table-column
            v-if="col.type === 'stat'"
            :label="col.label"
            :prop="col.field"
            :key="col.field"
            align="right"
            header-align="center"
            min-width="200"
          >
            <template slot="header">
              <switch-table-stat-type v-model="tableStatType" align="right"></switch-table-stat-type>
            </template>
            <template slot-scope="scope">
              <table-cell-value
                :row="scope.row"
                :col="col"
                :col-name="tableStatType"
                :show-compare-date="showCompareDate"
                :can-export-num-cols="canExportNumCols"
                @submitSaveCrowd="handleSubmitSaveCrowd"
              ></table-cell-value>
            </template>
          </el-table-column>
          <el-table-column
            :key="col.field"
            :label="col.label"
            :prop="col.field"
            align="right"
            header-align="center"
            :show-overflow-tooltip="true"
            min-width="200"
            v-else
          >
            <template slot="header" slot-scope="scope">
              <div style="display: flex; flex-direction: column; padding: 0; line-height: 20px">
                <span
                  v-for="(l, idx) in scope.column.label.split('/')"
                  :key="l + '-' + idx"
                  style="line-height: 20px; padding: 0; text-align: right"
                  :class="{ 'data-compare': !!idx, 'data-base': !idx }"
                >
                  {{ l }}
                </span>
              </div>
            </template>
            <template slot-scope="scope">
              <table-cell-value
                :row="scope.row"
                :col="col"
                :col-name="col.field"
                :show-compare-date="showCompareDate"
                :can-export-num-cols="canExportNumCols"
                :last-get-data-params="lastGetDataParams"
                :last-get-data-params-compare="lastGetDataParamsCompare"
                @submitSaveCrowd="handleSubmitSaveCrowd"
              ></table-cell-value>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="footer">
        <t-pagination
          v-model="paginationData.page"
          :total="paginationData.total"
          :page-size.sync="paginationData.pageSize"
          @current-change="handlePageChange"
          @page-size-change="handlePageSizeChange"
        />
      </div>
    </div>
    <no-data v-else></no-data>
  </my-card>
</template>
<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
import noData from '@/components/common/no-data-card.vue';
import { savePackageEvent } from '@/api/analysis/custom-analysis';
// import SaveCrowd from './save-crowd';
// import NumPopver from './num-popover';
import SwitchTableStatType from '@/components/analysis/switch-table-stat-type.vue';
import TableCellValue from '@/views/analysis/event-analysis/components/table-cell-value.vue';

import { beautifyNumber, extractMetaConfig, getWeiduNameDesc, getWeiduValueDesc } from '@/utils/helper';

export default {
  components: {
    noData,
    // NumPopver,
    SwitchTableStatType,
    TableCellValue,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dateKeys: {
      type: Object, // {baseDateKeys: [], compareDateKeys: []}
    },
    unit: {
      type: String,
      default: 'day',
    },
    showCompareDate: {
      type: Boolean,
    },
    zhibiaoList: {
      type: Array,
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    shuxingWeiduOptions: {
      type: Array,
      default: () => [],
    },
    shuxingWeiduList: {
      type: Array,
      default: () => [],
    },
    lastGetDataParams: {
      // 最后一次成功请求数据的参数。因为用户可以随时更改页面上的配置，而不实际请求数据
      type: Object,
    },
    lastGetDataParamsCompare: {
      type: Object,
    },
    options: {
      type: Object,
    },
  },
  data() {
    return {
      saveCrowdVisible: false,
      selectParams: {},

      oriTableList: [],
      canExportNumCols: [], // 标记哪些列是数据列，可以被导出为人群，但实际能不能导出还要结合指标类型来判断

      tableShowType: true,
      tableStatType: 'valSum',
      paginationData: {
        total: 0,
        page: 1,
        pageSize: 20,
      },
    };
  },
  computed: {
    tableColumns() {
      const columns = [];
      const { unit } = this;
      // const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all');
      const { allWeiduList } = extractMetaConfig(this.lastGetDataParams);

      allWeiduList.forEach(witem => {
        columns.push({
          type: 'weidu',
          label: getWeiduNameDesc(this.shuxingWeiduOptions, witem),
          field: witem.val,
        });
      });
      columns.push({
        label: '指标',
        field: 'target_name',
      });
      columns.push({
        label: '统计方式',
        field: 'statType',
        type: 'stat',
      });

      const { baseDateKeys, compareDateKeys } = this.dateKeys;
      baseDateKeys.forEach((dk, idx) => {
        let columnName = dayjs(dk).format(unit === 'day' ? 'MM-DD' : 'MM-DD HH:mm');
        const dateArr = [dayjs(dk).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss')];
        if (this.showCompareDate) {
          columnName = [columnName, dayjs(compareDateKeys[idx]).format(unit === 'day' ? 'MM-DD' : 'MM-DD HH:mm')].join(
            '/',
          );
          dateArr.push(dayjs(compareDateKeys[idx]).format(unit === 'day' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'));
        }
        columns.push({
          label: columnName,
          field: `date${idx}`,
          dateArr,
        });
      });
      return columns;
    },
    tableList() {
      const start = (this.paginationData.page - 1) * this.paginationData.pageSize;
      const end = start + this.paginationData.pageSize;

      return this.oriTableList.slice(start, end);
    },
  },
  directives: {
    clickExtra: {
      bind(el, binding, vnode) {
        // eslint-disable-next-line consistent-return
        function clickHandler(e) {
          if (!el.contains(e.target)) {
            // 点击的不是自己
            return false;
          }
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            // binding.value(e);
            // 这里进行了修改， 使用arg 传递函数名称， 使用value 传递 变量值
            // console.log("接收到 的arg为: " + funcName)
            // console.log("接收到的 value 为: " +  binding.value)
            const that = vnode.context;
            that[binding.arg](binding.value);
          }
        }
        // eslint-disable-next-line no-underscore-dangle
        el.__click_extra__ = clickHandler;
        el.addEventListener('click', clickHandler);
      },
      update() {},
      unbind(el) {
        // 解除事件监听
        // eslint-disable-next-line no-underscore-dangle
        el.removeEventListener('click', el.__click_extra__);
        // eslint-disable-next-line no-underscore-dangle
        delete el.__click_extra__;
      },
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        // console.log('watch options change', Date.now(), JSON.stringify(a), JSON.stringify(b));
        this.makeTableList();
      },
    },
  },
  async created() {
    //
  },
  mounted() {
    this.makeTableList();
  },
  methods: {
    resetData() {
      this.oriTableList = [];
      this.canExportNumCols = [];
      this.paginationData.total = 0;
      this.paginationData.page = 1;
    },

    makeTableList() {
      // console.log('event-analysis-table makeTableList', Date.now());
      this.resetData();

      const list = [];
      const canExportNumCols = [];
      const { baseDateKeys, compareDateKeys } = this.dateKeys;
      // const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all');
      const { allWeiduList } = extractMetaConfig(this.lastGetDataParams);

      // 哪些列是可能被导出成人群
      canExportNumCols.push('valSum');
      baseDateKeys.forEach((dk, idx) => {
        canExportNumCols.push(`date${idx}`);
      });

      const { seriesMap, seriesMapCompare } = this.options;

      seriesMap.forEach(seriesItem => {
        const tmpItem = {};
        Object.assign(tmpItem, seriesItem);
        // allWeiduList.forEach(wd => {
        //   tmpItem[wd.val] = getWeiduValueDesc(this.lastGetDataParams, wd, tmpItem);
        // });
        tmpItem.valSum = [beautifyNumber(tmpItem.valSum, '-')];
        tmpItem.valAvg = [beautifyNumber(tmpItem.valAvg, '-')];

        let compareSeriesItem;
        if (this.showCompareDate) {
          compareSeriesItem = seriesMapCompare.find(ti => ti.uniqKey === seriesItem.uniqKey);
          tmpItem.valSum.push(
            compareSeriesItem && compareSeriesItem.valSum !== null
              ? beautifyNumber(compareSeriesItem.valSum, '-')
              : '-',
          );
          tmpItem.valAvg.push(
            compareSeriesItem && compareSeriesItem.valSum !== null
              ? beautifyNumber(compareSeriesItem.valAvg, '-')
              : '-',
          );
        }

        baseDateKeys.forEach((dk, idx) => {
          const findValObj = seriesItem.list.find(slitem => String(slitem.date) === String(dk)) || {
            date: dk,
            val: '-',
          };
          const tmpDateVal = [findValObj.val];

          if (this.showCompareDate && compareSeriesItem) {
            const compareDateKey = compareDateKeys[idx];
            const findCompareValObj = compareSeriesItem.list.find(
              slitem => String(slitem.date) === String(compareDateKey),
            ) || { date: compareDateKey, val: '-' };
            tmpDateVal.push(findCompareValObj.val);
          }
          if (this.showCompareDate && !compareSeriesItem) {
            tmpDateVal.push('-');
          }
          tmpItem[`date${idx}`] = tmpDateVal;
        });

        // 判断是否可以导出人群
        const findZhibiaoIdx = this.zhibiaoList.findIndex(i => i.zhibiaoTitle === tmpItem.target_name);
        if (findZhibiaoIdx !== -1) {
          const findZhibiao = this.zhibiaoList[findZhibiaoIdx];
          if (findZhibiao.eventList.length === 1 && findZhibiao.eventList[0].eventTargetColumn.type === 'totalPeople') {
            tmpItem.canRowExportCrowd = true;
          }
        }
        tmpItem.zhibiaoIdx = findZhibiaoIdx; // 表示第几个指标

        list.push(tmpItem);
      });

      list.sort((a, b) => {
        const aKey = a.wdUniqKey + a.zhibiaoIdx;
        const bKey = b.wdUniqKey + b.zhibiaoIdx;
        if (aKey > bKey) {
          return 1;
        }
        if (aKey < bKey) {
          return -1;
        }
        return 0;
      });

      this.paginationData.total = list.length;
      this.oriTableList = list;
      this.canExportNumCols = canExportNumCols;
    },

    async handleSubmitSaveCrowd({ row, col, idx = 0 }, { name, desc }, callback) {
      let val = row[col.type === 'stat' ? this.tableStatType : col.field];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      if (val > 1000000) {
        this.toast('人群数超100万，暂不支持提取', 'warning');
        return;
      }

      const latitude = {};
      const reqParams = {
        eventInfo: idx === 0 ? this.lastGetDataParams : this.lastGetDataParamsCompare,
        packageName: name,
        packageDesc: desc,
        eventPosition: row.zhibiaoIdx,
        latitude,
      };
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all').map(i => i.val);
      weiduList.forEach(w => {
        latitude[w] = row[w];
      });
      if (col.type !== 'stat') {
        latitude.import_date = col.dateArr[idx];
      }
      try {
        const packageId = await savePackageEvent({ data: reqParams });
        // eslint-disable-next-line no-unused-expressions
        callback && callback(packageId);
      } finally {
        // nothing
      }
    },

    checkCanExportCrowd(row, col, idx = 0) {
      let colName = col.field;
      if (col.type === 'stat') {
        colName = this.tableStatType;
      }
      let val = row[colName];
      if (Array.isArray(val)) {
        val = val[idx];
      }
      return this.canExportNumCols.includes(colName) && !!row.canRowExportCrowd && val > 0;
    },

    handlePageSizeChange(pageSize) {
      this.paginationData.pageSize = pageSize;
    },

    handlePageChange(page) {
      this.paginationData.page = page;
    },

    handleTableRowClassName({ row }) {
      return row.canRowExportCrowd ? 'export-people-row' : '';
    },

    handleTableSpanMethod({ row, column, rowIndex, columnIndex }) {
      const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all').map(i => i.val);
      const { property } = column;
      const prevRow = this.tableList[rowIndex - 1] || {};
      const prevColumn = this.tableColumns[columnIndex - 1] || {};

      if (weiduList.includes(property)) {
        if (columnIndex === 0) {
          if (row[property] === prevRow[property]) {
            return {
              rowspan: 0,
              colspan: 1,
            };
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableList.length; i++) {
            if (this.tableList[i][property] !== row[property]) {
              break;
            }
            rowspan += 1;
          }
          return {
            rowspan,
            colspan: 1,
          };
        }
        const prevProperty = prevColumn.field;
        if (row[prevProperty] === prevRow[prevProperty]) {
          if (row[property] === prevRow[property]) {
            return {
              rowspan: 0,
              colspan: 1,
            };
          }
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableList.length; i++) {
            if (
              this.tableList[i][prevProperty] !== row[prevProperty] ||
              this.tableList[i][property] !== row[property]
            ) {
              break;
            }
            rowspan += 1;
          }
          return {
            rowspan,
            colspan: 1,
          };
        }
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableList.length; i++) {
          if (this.tableList[i][prevProperty] !== row[prevProperty] || this.tableList[i][property] !== row[property]) {
            break;
          }
          rowspan += 1;
        }
        return {
          rowspan,
          colspan: 1,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };

      // return {
      //   rowspan: 1,
      //   colspan: 1,
      // };
    },

    handleChangeTableShowType(v) {
      this.$emit('onChangeTableShowType', v ? 'row' : 'col');
    },

    handleExportTableData() {
      const cols = JSON.parse(JSON.stringify(this.tableColumns));
      const { tableStatType } = this;
      // const fileName = `腾讯有数-事件分析结果-${dayjs().format('YYYY-MM-DD')}.xlsx`;
      const fileName = '分析结果.xlsx';
      const data = [];
      // eslint-disable-next-line array-callback-return
      data.push(
        cols.map(col => {
          if (col.type === 'stat') {
            return tableStatType === 'valSum' ? '合计' : '均值';
          }
          return col.label;
        }),
      );
      function formatValue(v) {
        if (v === undefined) {
          return '';
        }
        if (Array.isArray(v) && v.length > 1) {
          // 数量大于1，才用join，这样生成的是字符串，在excel不能参与数字计算
          return v.join('/');
        }
        return v;
      }
      this.oriTableList.forEach(item => {
        const tmpArr = [];
        cols.forEach(col => {
          let val;
          if (col.type === 'stat') {
            val = item[tableStatType];
          } else {
            val = item[col.field];
          }
          tmpArr.push(formatValue(val));
        });
        data.push(tmpArr);
      });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '事件分析数据');
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>
<style lang="less" scoped></style>
